module.exports = __webpack_public_path__ + "img/handoff-requestsent-icon.fbe4f7ec.png";